// src/components/auth/MockAuth0Provider.jsx

import React, { createContext, useContext } from 'react';
import { MOCK_USER } from '@/lib/config'; // Importe o usuário mock

// 1. Crie um contexto que simula o contexto do Auth0
const MockAuth0Context = createContext();

// 2. Crie o provedor falso
export const MockAuth0Provider = ({ children }) => {
  const mockAuth = {
    isAuthenticated: true,
    isLoading: false,
    user: MOCK_USER,
    logout: () => {
      console.log("Logout simulado. Em um app real, isso redirecionaria.");
      alert("Logout simulado!");
    },
    loginWithRedirect: () => console.log("Login simulado."),
    getAccessTokenSilently: async () => "mock-access-token", // Retorna um token falso
  };

  return (
    <MockAuth0Context.Provider value={mockAuth}>
      {children}
    </MockAuth0Context.Provider>
  );
};

// 3. Crie um hook 'useAuth0' falso que consome nosso contexto mock
export const useAuth0 = () => useContext(MockAuth0Context);
